import {useQuery} from "@tanstack/react-query"
import {isEmpty} from "lodash"
import {userService} from "services"
import {Auth} from "types/auth"
import {useModel} from "./useModel"

export const useStudentFieldLabels = () => {
    const model = useModel()
    const cachedLabels = !isEmpty(model.fieldLabels)
        ? (model.fieldLabels as unknown as Auth.StudentLabelInfo)
        : undefined

    const query = useQuery(["student-field-labels"], () => userService.getLabels(), {
        initialData: cachedLabels,
        staleTime: 30 * 60 * 1000 // 30 minutes
    })

    const locale = model.getLocale() || "en"
    const labelKey = locale === "en" ? "english" : "spanish"

    return {
        studentLabelInfo: query.data,
        labelKey,
        isLoading: query.isLoading && !query.data
    }
}
